import type { CSSProperties } from 'react';
import { InheritedSpanTertiaryTextVariant } from '../Csessionpage/sessionTweaks';
import { INLINE_INHERIT_TYPOGRAPHY_STYLE } from './inline-typography-style';

const MINT_HAIRLINE = 'rgba(102,254,193,0.32)';
const EASE = 'cubic-bezier(0.32, 0.72, 0, 1)';

const INHERITED_SPAN_TERTIARY_TEXT_STYLE_BY_VARIANT: Record<
  InheritedSpanTertiaryTextVariant,
  CSSProperties
> = {
  [InheritedSpanTertiaryTextVariant.Classic]: {
    ...INLINE_INHERIT_TYPOGRAPHY_STYLE,
  },
  [InheritedSpanTertiaryTextVariant.Whisper]: {
    ...INLINE_INHERIT_TYPOGRAPHY_STYLE,
    opacity: 0.68,
    transition: `opacity 640ms ${EASE}`,
  },
  [InheritedSpanTertiaryTextVariant.Etched]: {
    ...INLINE_INHERIT_TYPOGRAPHY_STYLE,
    textShadow: '0 1px 0 rgba(255,255,255,0.06), 0 -1px 0 rgba(0,0,0,0.28)',
    transition: `text-shadow 640ms ${EASE}`,
  },
  [InheritedSpanTertiaryTextVariant.MintFilament]: {
    ...INLINE_INHERIT_TYPOGRAPHY_STYLE,
    textDecorationLine: 'underline',
    textDecorationColor: MINT_HAIRLINE,
    textDecorationThickness: '1px',
    textUnderlineOffset: '0.18em',
    transition: `text-decoration-color 640ms ${EASE}`,
  },
  [InheritedSpanTertiaryTextVariant.DewFilm]: {
    ...INLINE_INHERIT_TYPOGRAPHY_STYLE,
    backgroundColor: 'rgba(255,255,255,0.04)',
    borderRadius: '0.35em',
    padding: '0.06em 0.28em',
    boxDecorationBreak: 'clone',
    WebkitBoxDecorationBreak: 'clone',
    boxShadow: 'inset 0 1px 0 rgba(255,255,255,0.08)',
    transition: `background-color 640ms ${EASE}, box-shadow 640ms ${EASE}`,
  },
  [InheritedSpanTertiaryTextVariant.Porcelain]: {
    ...INLINE_INHERIT_TYPOGRAPHY_STYLE,
    backgroundColor: 'rgba(255,255,255,0.06)',
    borderRadius: '0.42em',
    padding: '0.08em 0.32em',
    boxDecorationBreak: 'clone',
    WebkitBoxDecorationBreak: 'clone',
    boxShadow: [
      'inset 0 1px 0 rgba(255,255,255,0.12)',
      'inset 0 0 0 1px rgba(255,255,255,0.08)',
    ].join(', '),
    transition: `box-shadow 640ms ${EASE}, background-color 640ms ${EASE}`,
  },
  [InheritedSpanTertiaryTextVariant.EditorialTrack]: {
    ...INLINE_INHERIT_TYPOGRAPHY_STYLE,
    letterSpacing: '0.03em',
    fontFeatureSettings: '"ss01" 1',
    opacity: 0.88,
    transition: `opacity 640ms ${EASE}, letter-spacing 640ms ${EASE}`,
  },
};

export function getInheritedSpanTertiaryTextStyle(
  variant: InheritedSpanTertiaryTextVariant,
): CSSProperties {
  return INHERITED_SPAN_TERTIARY_TEXT_STYLE_BY_VARIANT[variant];
}

export function resolveInheritedSpanTertiaryTextStyle(input: {
  variant: InheritedSpanTertiaryTextVariant;
  underlineStyle?: CSSProperties;
}): CSSProperties {
  return {
    ...input.underlineStyle,
    ...getInheritedSpanTertiaryTextStyle(input.variant),
  };
}
